import React, {Component} from 'react';
import PropTypes from "prop-types";
import AnyChart from "anychart-react";

class ChartColumn extends Component {

  render() {
    const {id, data, n} = this.props;
    let stage = anychart.graphics.create();
    var chart = anychart.column(data);
    chart.yScale().minimum(0);
    chart.yScale().maximum(n);
    chart.labels().enabled(true).format(row => Math.round(row.value / n * 1000) / 10 + '%');

    var tooltip = chart.getSeries(0).tooltip();
    tooltip.format(row => "Liczba wskazań: " + row.value + "\nProcentowo: " + Math.round(row.value / n * 1000) / 10 + "%");

    var yAxis2 = chart.yAxis(1);
    yAxis2.orientation("right");
    yAxis2.labels().format(row => Math.round(row.tickValue / n * 1000) / 10 + '%');

    return (
      <AnyChart
        id={'question-' + id}
        instance={stage}
        height={400}
        charts={[chart]}
        yAxis={{
          labels: {
            wordWrap: 'break-word',
            wordBreak: 'break-all',
          }
        }}
        xAxis={{
          overlapMode: 'allowOverlap',
          labels: {
            width: parseInt((92 / data.length), 10) + '%',
            hAlign: 'center',
            textWrap: 'byLetter',
            wordWrap: 'break-word',
            wordBreak: 'break-all',
          }
        }}
      />
    )
  }
}

ChartColumn.propTypes = {
  id: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,).isRequired,
  n: PropTypes.number.isRequired
};

export default ChartColumn;